export enum AddRundownCuePosition {
  BEFORE = 'before',
  AFTER = 'after',
}

export enum ColumnType {
  HEADING_COLUMN = 'heading-column',
}
